import { h, Fragment, } from '@stencil/core';
import cn from 'classnames';
import { productCtasButtonType, productCtasColors, EEvent, EQdsButtonImportance, EQdsButtonSize, RANGE, pesCatalogPageTypes, gaLocationNames, comparator, paginationClickEvent, exitToSchneiderEvent, send, triggerCtaClickEvent, ConfiguratorHandler } from '@pes-ui/utils';
import { isEmpty } from 'lodash';
import { isMobile } from '../../../globals/utils';
import { getMyProductsFromConnector } from '../../pes-my-products-connector/utils';
import { getCountry, getLanguage, scrollToTop } from '../../../globals/utils/helpers';
export class RangeProductsTab {
  constructor() {
    var _a;
    this.ctaLocation = gaLocationNames[pesCatalogPageTypes.RANGE] || '';
    this.hyperPersonalizationFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.hyperPersonalization;
    this.isHyperPersonalizationEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.hyperPersonalizationFlag || {});
    this.handleComparatorChange = (e) => {
      this.comparatorValue = e.detail;
    };
    this.handleMarketingBannerClick = (url, event) => {
      var _a, _b;
      event.preventDefault();
      send(exitToSchneiderEvent, {
        link_url: url,
      });
      window.open(url, '_blank');
      if (!this.rangeBanner.gaAttributes) {
        console.warn('[PES]: Could not find gaAttributes from API response');
        return;
      }
      triggerCtaClickEvent({
        cta_id: '',
        cta_name: (_a = this.rangeBanner.gaAttributes) === null || _a === void 0 ? void 0 : _a.type,
        cta_link: url,
        cta_location: this.ctaLocation,
        cta_category: ((_b = this.rangeBanner.gaAttributes) === null || _b === void 0 ? void 0 : _b.category) || '',
      });
    };
    this.onPaginationChange = (event) => {
      const pageNumber = event.detail.value;
      send(paginationClickEvent, { articleTitle: pageNumber });
      this.pageSelected.emit(pageNumber);
      scrollToTop(this.el);
    };
    this.loadPrevious = () => {
      const previousPageNumber = Math.floor(this.firstLoadedRecNum / this.productsPerPage);
      send(paginationClickEvent, { articleTitle: previousPageNumber });
      this.pageSelected.emit(previousPageNumber);
      this.scrollToProduct = this.productsPerPage;
    };
    this.loadMore = () => {
      const nextPageNumber = Math.floor(this.lastLoadedRecNum / this.productsPerPage) + 1;
      send(paginationClickEvent, { articleTitle: nextPageNumber });
      this.pageSelected.emit(nextPageNumber);
      this.scrollToProduct = this.lastLoadedRecNum - this.firstLoadedRecNum + 1;
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      if (this.isPBS) {
        this.productCtas = Object.assign({}, this.productCtas);
        return;
      }
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.labels = undefined;
    this.rangeBanner = undefined;
    this.hostWithLocale = undefined;
    this.host = undefined;
    this.currentNode = undefined;
    this.name = undefined;
    this.filters = undefined;
    this.filtrationSmartData = undefined;
    this.navigationState = undefined;
    this.productList = undefined;
    this.productUrlParams = undefined;
    this.pills = undefined;
    this.categories = undefined;
    this.productsPerPage = undefined;
    this.productsCount = undefined;
    this.selectedPage = undefined;
    this.isLoading = undefined;
    this.isMobileCategorySelected = undefined;
    this.siteType = undefined;
    this.isPBS = undefined;
    this.localeCode = undefined;
    this.id = undefined;
    this.showDocuments = undefined;
    this.resultCount = undefined;
    this.firstLoadedRecNum = undefined;
    this.lastLoadedRecNum = undefined;
    this.productCtas = {
      buttons: {
        [productCtasButtonType.CART]: {
          isShown: false,
          list: [],
          color: productCtasColors.PRIMARY_BLUE,
          icons: {
            addIcon: "shopping-cart",
            disableIconInPdpCtaBlock: true,
          },
          dataset: {
            daElementId: 'add_p',
          },
          labels: {},
        },
        [productCtasButtonType.FAVORITES]: {
          isShown: false,
          list: [],
          color: productCtasColors.SECONDARY_BLUE,
          icons: {
            addIcon: "star",
            removeIcon: "star-on",
          },
          dataset: {
            daElementId: 'add_p',
          },
          labels: {},
        },
      },
      productProp: 'repositoryId',
    };
    this.richText = undefined;
    this.enableCommerceConnector = undefined;
    this.showBuyOnline = true;
    this.selectedSectionsCount = undefined;
    this.showCompare = true;
    this.enableAppRouting = false;
    this.isExternalConsumer = undefined;
    this.externalUrlConfig = undefined;
    this.externalFavoriteConfig = undefined;
    this.analyticsPageData = undefined;
    this.isFilterMobileViewVisible = false;
    this.isMobileView = false;
    this.scrollToProduct = undefined;
    this.comparatorValue = comparator.value;
    this.productCtasState = this.productCtas;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  windowSizeDidChange() {
    if (!isMobile() && this.isFilterMobileViewVisible === true) {
      this.isFilterMobileViewVisible = false;
    }
    this.isMobileView = isMobile();
  }
  connectedCallback() {
    window.addEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  disconnectedCallback() {
    window.removeEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  componentWillLoad() {
    var _a, _b;
    this.isMobileView = isMobile();
    if (isEmpty(this.rangeBanner))
      return;
    this.rangeBanner.url = (_b = (_a = this.rangeBanner.url).replace) === null || _b === void 0 ? void 0 : _b.call(_a, 'cta_location=<location>', `cta_location=${this.ctaLocation}`);
  }
  productCtasDidChange(newProductCtas) {
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get productIds() {
    return this.productList;
  }
  get totalPages() {
    return Math.ceil(this.productsCount / this.productsPerPage);
  }
  getAdditionalMainQueryParams() {
    return { nodeOrSubCatId: this.navigationState, isCategoryListing: false };
  }
  renderProductCardsWrapper() {
    var _a, _b, _c;
    return (h("product-cards-wrapper", { showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, comparator: this.comparatorValue, enableCommerceConnector: this.enableCommerceConnector, "product-ids": this.productIds, host: this.host, hostWithLocale: this.hostWithLocale, class: "range-products-tab__products-list", productCtas: this.productCtas, productOfProductsLabel: this.labels.numberProductsOfAllProductsLabel, productsLabel: this.labels.appProductsLabel, productUrlParams: this.productUrlParams, firstRecNum: (_a = this.resultCount) === null || _a === void 0 ? void 0 : _a.firstRecNum, lastRecNum: (_b = this.resultCount) === null || _b === void 0 ? void 0 : _b.lastRecNum, totalNumRecs: (_c = this.resultCount) === null || _c === void 0 ? void 0 : _c.totalNumRecs, areListGridLabelsShown: false, scrollToProduct: this.scrollToProduct, siteType: this.siteType, enableAppRouting: this.enableAppRouting, additionalMainQueryParams: this.getAdditionalMainQueryParams(), localeCode: this.localeCode, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalFavoriteConfig: this.externalFavoriteConfig, currentPageStorageKey: `${RANGE}/${this.id}`, isProductListing: true, analyticsPageData: this.analyticsPageData, parentPage: pesCatalogPageTypes.RANGE }, h("div", { slot: "pills" }, h("pes-range-filter-pills", { pills: this.pills }))));
  }
  onToggleFilterMobileViewVisibility() {
    this.isFilterMobileViewVisible = !this.isFilterMobileViewVisible;
  }
  renderNodes() {
    return (h("se-block", { color: "none", class: "range-products-tab__nodes-wrapper" }, h("pes-range-nodes", { backUrl: this.currentNode.backUrl, backUrlTitle: this.currentNode.backUrlTitle, levelTitle: this.currentNode.levelTitle, childrenNodes: this.currentNode.childrenNodes, isPBS: this.isPBS })));
  }
  renderFilters() {
    return this.filtrationSmartData ? (h("pes-responsive-filters", { class: "range-products-tab__filters", filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.labels.facetButtonResetAllLabel, viewMoreFacetsLabel: this.labels.facetButtonViewMoreFilters, viewLessFacetsLabel: this.labels.facetButtonViewLessFilters, headerLabelDesktop: this.labels.commonFiltersFilterBy, headerLabelMobile: this.labels.rangeProductsFiltersLabel, viewProductsLabel: this.labels.viewProductsLabel, viewMoreRefinementsLabel: this.labels.viewMoreLabel, viewLessRefinementsLabel: this.labels.viewLessLabel, isMobileViewVisible: this.isFilterMobileViewVisible, isMobileCategorySelected: this.isMobileCategorySelected, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: this.categories, onShowMobileFilter: () => (this.isFilterMobileViewVisible = true) })) : null;
  }
  renderProducts() {
    var _a, _b, _c, _d;
    return (h("se-block", { direction: "row", color: "standard", class: cn('range-products-tab__products', 'range-products-tab__main-block-wrapper', {
        'range-products-tab__products--desktop': this.isFilterMobileViewVisible
          || (((_a = this.categories) === null || _a === void 0 ? void 0 : _a.length) !== 0 && !this.isMobileCategorySelected),
      }) }, this.isMobileCategorySelected && (h("div", { class: "range-products-tab__products-count" }, this.labels.rangeProductLabel, ": ", this.productsCount)), this.productList && this.isMobileCategorySelected && this.firstLoadedRecNum > 1 && (h("qds-button", { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.STANDARD, class: "range-products-tab__load-prev-btn", onClick: this.loadPrevious, text: this.labels.loadPreviousLabel })), h("pes-rich-text-information", { richText: this.richText, class: "range-products-tab__rich-text" }), h("pes-range-product-ctas-updater", { buttons: (_b = this.productCtas) === null || _b === void 0 ? void 0 : _b.buttons, myProductsGetter: getMyProductsFromConnector, onButtonsChange: this.handleProductCtasChange }), ((_c = this.productList) === null || _c === void 0 ? void 0 : _c.length) > 0 || this.isLoading
      ? this.renderProductCardsWrapper()
      : !((_d = this.richText) === null || _d === void 0 ? void 0 : _d.length) && (h("pes-filters-no-results", { noResultsClearLink: this.labels.noResultsClearLink, noResultsHeader: this.labels.noResultsHeader, noResultsMessage: this.labels.noResultsMessage })), this.productList && this.productsCount > this.productsPerPage && (h("se-pagination", { hideEdge: true, perPage: this.productsPerPage, total: this.totalPages, value: this.selectedPage, labelValue: this.labels.labelValue, labelPrev: this.labels.previousLabel, labelNext: this.labels.nextLabel, onDidChange: this.onPaginationChange, class: "range-products-tab__desktop-pagination" })), this.productList
      && this.isMobileCategorySelected
      && this.lastLoadedRecNum < this.productsCount && (h("qds-button", { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.STANDARD, class: "range-products-tab__load-more-btn", onClick: this.loadMore, text: this.labels.loadMoreLabel }))));
  }
  render() {
    var _a, _b;
    return (h(Fragment, null, h("se-container", { color: "standard", class: "range-products-tab" }, h("div", { class: {
        'range-products-tab__overlay': true,
        'range-products-tab__overlay--visible': this.isLoading,
      } }), !isEmpty(this.rangeBanner) ? (h("pes-marketing-banner", { cta: { label: this.rangeBanner.rangeBannerLabel, url: this.rangeBanner.url }, title: this.rangeBanner.title, description: this.rangeBanner.description, iconName: this.rangeBanner.iconName, onCTAClick: this.handleMarketingBannerClick })) : null, ((_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.showNodes) && this.renderNodes(), ((_b = this.currentNode) === null || _b === void 0 ? void 0 : _b.showProducts) && (h("div", { class: "range-products-tab__container" }, this.isHyperPersonalizationEnabled
      && (h("pes-recommendations", { pageType: pesCatalogPageTypes.RANGE, pageId: this.id, countryCode: getCountry(this.localeCode), languageCode: getLanguage(this.localeCode) })), h("div", { class: "range-products-tab__main-block-container" }, this.renderFilters(), this.renderProducts()))))));
  }
  static get is() { return "pes-range-products-tab"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-products-tab.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-products-tab.css"]
    };
  }
  static get properties() {
    return {
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{\n    commonFiltersFilterBy: string;\n    facetButtonResetAllLabel: string;\n    rangeProductsFiltersLabel: string;\n    facetButtonViewMoreFilters: string;\n    facetButtonViewLessFilters: string;\n    previousLabel: string;\n    nextLabel: string;\n    labelValue: string;\n    viewProductsLabel: string;\n    rangeProductLabel: string;\n    appProductsLabel: string;\n    numberProductsOfAllProductsLabel: string;\n    noResultsClearLink?: string;\n    noResultsHeader?: string;\n    noResultsMessage?: string;\n    viewMoreLabel: string;\n    viewLessLabel: string;\n    loadMoreLabel: string;\n    loadPreviousLabel: string;\n  }",
          "resolved": "{ commonFiltersFilterBy: string; facetButtonResetAllLabel: string; rangeProductsFiltersLabel: string; facetButtonViewMoreFilters: string; facetButtonViewLessFilters: string; previousLabel: string; nextLabel: string; labelValue: string; viewProductsLabel: string; rangeProductLabel: string; appProductsLabel: string; numberProductsOfAllProductsLabel: string; noResultsClearLink?: string; noResultsHeader?: string; noResultsMessage?: string; viewMoreLabel: string; viewLessLabel: string; loadMoreLabel: string; loadPreviousLabel: string; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "rangeBanner": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "MarketingBannerData",
          "resolved": "MarketingBannerData",
          "references": {
            "MarketingBannerData": {
              "location": "import",
              "path": "../../reusable/marketing-banner/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "hostWithLocale": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hostWithLocale contains host, countryCode and languageCode"
        },
        "attribute": "host-with-locale",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "host does not contain countryCode and languageCode"
        },
        "attribute": "host",
        "reflect": false
      },
      "currentNode": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CalculatedCurrentNode",
          "resolved": "{ backUrl?: string; backUrlTitle?: string; levelTitle?: string; childrenNodes?: RangeNode[]; navigationState?: string; id?: string; currentNodeUrl: string; showNodes: boolean; showProducts: boolean; }",
          "references": {
            "CalculatedCurrentNode": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "filters": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "FiltersData[]",
          "resolved": "FiltersData[]",
          "references": {
            "FiltersData": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "filtrationSmartData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "FiltrationSmartData",
          "resolved": "FiltrationSmartData",
          "references": {
            "FiltrationSmartData": {
              "location": "import",
              "path": "@se/web-ui/types/components/filtration-smart/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "navigationState": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "navigation-state",
        "reflect": false
      },
      "productList": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-list",
        "reflect": false
      },
      "productUrlParams": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-url-params",
        "reflect": false
      },
      "pills": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductsPillsData[]",
          "resolved": "TProductsPillsData[]",
          "references": {
            "TProductsPillsData": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "categories": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TFiltersCategory[]",
          "resolved": "TFiltersCategory[]",
          "references": {
            "TFiltersCategory": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productsPerPage": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-per-page",
        "reflect": false
      },
      "productsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-count",
        "reflect": false
      },
      "selectedPage": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-page",
        "reflect": false
      },
      "isLoading": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-loading",
        "reflect": false
      },
      "isMobileCategorySelected": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile-category-selected",
        "reflect": false
      },
      "siteType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TSiteType",
          "resolved": "\"b2b\" | \"b2c\"",
          "references": {
            "TSiteType": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "site-type",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Range id"
        },
        "attribute": "id",
        "reflect": false
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "If show Documents CTA and documents list in product-card"
        },
        "attribute": "show-documents",
        "reflect": false
      },
      "resultCount": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TResultsCount",
          "resolved": "{ firstRecNum: number; lastRecNum: number; totalNumRecs: number; recsPerPage: number; }",
          "references": {
            "TResultsCount": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Object containing info about currently displayed records and total number of records"
        }
      },
      "firstLoadedRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Index of the first loaded record, 1-based (for mobile pagination)."
        },
        "attribute": "first-loaded-rec-num",
        "reflect": false
      },
      "lastLoadedRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Index of the last loaded record, 1-based (for mobile pagination)."
        },
        "attribute": "last-loaded-rec-num",
        "reflect": false
      },
      "productCtas": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            },
            "TCTAButtonSettings": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        },
        "defaultValue": "{\n    buttons: {\n      [productCtasButtonType.CART]: {\n        isShown: false,\n        list: [],\n        color: productCtasColors.PRIMARY_BLUE,\n        icons: {\n          addIcon: EQdsIcons.SHOPPING_CART,\n          disableIconInPdpCtaBlock: true,\n        },\n        dataset: {\n          daElementId: 'add_p',\n        },\n        labels: {},\n      } as TCTAButtonSettings,\n      [productCtasButtonType.FAVORITES]: {\n        isShown: false,\n        list: [],\n        color: productCtasColors.SECONDARY_BLUE,\n        icons: {\n          addIcon: EQdsIcons.STAR,\n          removeIcon: EQdsIcons.STAR_FILLED,\n        },\n        dataset: {\n          daElementId: 'add_p',\n        },\n        labels: {},\n      } as TCTAButtonSettings,\n    },\n    productProp: 'repositoryId',\n  }"
      },
      "richText": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-commerce-connector",
        "reflect": false
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "selectedSectionsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-sections-count",
        "reflect": false
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "enableAppRouting": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "PBS application routing functionality configuration."
        },
        "attribute": "enable-app-routing",
        "reflect": false,
        "defaultValue": "false"
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "externalUrlConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TExternalUrlConfig",
          "resolved": "{ viewDetail: string[]; substitution: string[]; }",
          "references": {
            "TExternalUrlConfig": {
              "location": "import",
              "path": "../../../globals/external-consumer"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines customized url(s) of hyperlink for external-user"
        }
      },
      "externalFavoriteConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TExternalFavoritelConfig",
          "resolved": "{ host: string; localeCode: string; }",
          "references": {
            "TExternalFavoritelConfig": {
              "location": "import",
              "path": "../../../globals/external-consumer"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines favorite configuration for external-user"
        }
      },
      "analyticsPageData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "MetaTags['analyticsPageData']",
          "resolved": "{ articleTitle: string | number; businessUnit: string; pageRangeId: string; pageSubCategoryId: string; pageCategoryId: string; pageSubCategory: string; pageProductId: string; fromWebView: boolean; digitalPlatform: string; digitalPlatformCountry: string; pageLanguage: string; environment: string; template: string; pageSubSubCategory: string; pageTopCategory: string; pageCategory: string; pageTitle: string; }",
          "references": {
            "MetaTags": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isFilterMobileViewVisible": {},
      "isMobileView": {},
      "scrollToProduct": {},
      "comparatorValue": {},
      "productCtasState": {}
    };
  }
  static get events() {
    return [{
        "method": "pageSelected",
        "name": "pageSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event emitted on page select, contains number of the selected page."
        },
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "productCtas",
        "methodName": "productCtasDidChange"
      }];
  }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "windowSizeDidChange",
        "target": "window",
        "capture": false,
        "passive": true
      }, {
        "name": "toggleMobileView",
        "method": "onToggleFilterMobileViewVisibility",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
